import { useParams } from "react-router-dom";
import SolveesyWhitePaper from "./pages/Blogs/blog";
import SolveesyBlog from "./pages/Blogs";

const SolveesyRouteBlog = () => {
  const { id } = useParams();
console.log(id,"id")
  if (id === "1") return <SolveesyWhitePaper />;
  if (id === "2") return <SolveesyBlog />;

  return <div>Blog not found</div>;
};

export default SolveesyRouteBlog;